import { Enum  } from "./Enum";

export const StockTypeEnum: Enum[] = [
  { id: 'current', name: 'Current' },
  { id: 'incoming', name: 'Incoming' }
];
